import { gql } from '@apollo/client'

export const reorderGalleryCollectionMutation = gql`
  mutation ReorderGalleryCollection($records: [GalleryCollectionIndexChangeInput!]!) {
    reorderGalleryCollection(galleryCollections: $records)
  }
`
